import { ChatSession } from '../../../domain/chat/models/ChatSession';
import { ProviderServices } from '../../../services/chat/createProviderServices';
import { mapSendChatMessageCommandToProviderRequest } from '../mappers/mapSendChatMessageCommandToProviderRequest';
import { SendChatMessageCommand } from '../models/SendChatMessageCommand';
import { SendChatMessageHandlerResult } from '../models/SendChatMessageHandlerResult';
import { ChatProviderType } from '../../../domain/chat/models/ChatProviderType';
export interface SendChatMessageHandlerInput {
	command: SendChatMessageCommand;
	session: ChatSession;
	accessToken: string;
	providerServices: ProviderServices;
	signal?: AbortSignal;
}

export const sendChatMessageHandler = async ({
	command,
	session,
	accessToken,
	providerServices,
	signal,
}: SendChatMessageHandlerInput): Promise<SendChatMessageHandlerResult> => {
	const request = mapSendChatMessageCommandToProviderRequest(command, session);
	const selectedProviderServices = providerServices.providerServicesRouter.getProviderServices(
		session.providerType,
	);

	const response = await selectedProviderServices.messages.sendMessageAsync(request, accessToken, signal);
	// this will be a confirmation that the message has been sent to the provider, not the actual response from the provider which will be received via SSE
	var title;
	if (session.providerType == ChatProviderType.ProGPT && session.isTitleGenerated != true) {
		title = await providerServices.nexus.titleGenerator.generateChatTitleAsync(
			{ message: request.input },
			accessToken
		)
	}

	return {
		sessionId: session.id,
		providerType: session.providerType,
		messageId: response.id,
		responseStatus: response.status,
		responseMessageText: response.message,
		citations: response.citations ?? [],
		agentId: response.agentId,
		agentSources: response.agentSources,
		generatedTitle: title?.title,
		tokens: response.tokens
	};
};

export default sendChatMessageHandler;

